import { orgEndPoints } from "./endPoints";
import { toast } from "react-toastify";
import { OrgApiClient } from "src/network/orgApiclient";
import toastManager from "src/helpers/toastManager";

 class OrgRepository{

    getOrgDetailsById = async(orgId) => {   
        let data = await OrgApiClient.get(orgEndPoints.getOrgDetailsById(orgId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getSubOrganizations = async(parentOrgId) => {
        let data = await OrgApiClient.get(orgEndPoints.getSubOrganizations(parentOrgId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }   

 }

const orgRepository = new OrgRepository();
export { orgRepository as OrgRepository };